import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone:false,
  selector: 'app-logo',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './logo.component.html'
})
export class LogoComponent { 
  readonly logoType = input<number>(0);

  get logoSource(){
    return '../assets/images/logos/detamoov-logo.png';
  }
}
